import { User } from '../user';

export class UserBuilder {
  static fromJson(json): User {
    return (json)
      ? new User(
        json.hash,
        json.firstname,
        json.lastname,
        json.email,
        json.birthDate
      )
      : null;
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/models/builders/user.builder.ts